import React from "react";

export const TextMedium = ({text,color}) => (
    <span className={`manager-component__text-medium ${color}`}>
        {text}
    </span>
);

export default TextMedium;